import React from 'react';
import { Alert, Stack } from '@mui/material';
import { SharedMessageBadge } from './SharedMessageBadge';

interface ReadOnlyMessageBannerProps {
  ownerCompanyName: string;
  visibilityOrigin?: string;
}

/**
 * Banner displayed at the top of shared message detail views.
 * Shows the owner company badge and a read-only notice.
 * Audio/track preview remains available while mutation actions are disabled.
 */
export const ReadOnlyMessageBanner: React.FC<ReadOnlyMessageBannerProps> = ({
  ownerCompanyName,
  visibilityOrigin,
}) => {
  return (
    <Alert
      severity='info'
      sx={{mb: 2}}
      icon={false}>
      <Stack direction='row' alignItems='center' spacing={1.5} flexWrap='wrap'>
        <SharedMessageBadge ownerCompanyName={ownerCompanyName} />
        <span>
          This message is read-only.
          {visibilityOrigin === 'district_parent' &&
            ' It is managed by the district and cannot be edited.'}
        </span>
      </Stack>
    </Alert>
  );
};
